import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	showMore: {
		id: 'servicedesk-insight-rapid-search-bar.popup-content.dropdown-container.show-more',
		defaultMessage: 'Show more',
		description: 'Link to allow the user to display more objects in the list',
	},
});
